import { Avatar, AvatarProps, Badge, styled } from '@mui/material';
import { COLOR_SECONDARY, COLOR_STROKE } from 'shared/config';

interface TokenAvatarProps extends Omit<AvatarProps, 'children'> {
  tokenImg: string | undefined | null;
  networkImg?: string | null;
  tokenName: string;
  networkName?: string;
  showNetwork?: boolean;
  size?: number;
}

const StyledAvatar = styled(Avatar, {
  shouldForwardProp: (prop) => prop !== '$size',
})<{ $size: number }>(({ $size }) => {
  return {
    width: $size,
    height: $size,
    fontSize: '95%',
    background: COLOR_STROKE,
  };
});

export const TokenAvatar = ({
  tokenImg,
  networkImg,
  tokenName,
  networkName,
  size = 30,
  showNetwork = true,
}: TokenAvatarProps) => {
  const showNetworkBadge = (!!networkImg || !!networkName) && showNetwork;
  return (
    <Badge
      overlap="circular"
      showZero
      anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      badgeContent={
        showNetworkBadge && (
          <StyledAvatar
            $size={size / 2}
            alt={networkName}
            src={networkImg ?? undefined}
            sx={{ transform: 'translateY(-25%)', background: COLOR_SECONDARY }}
          >
            {networkName?.[0]}
          </StyledAvatar>
        )
      }
    >
      <StyledAvatar $size={size} src={tokenImg ?? undefined} alt={tokenName} sx={{ border: 'none' }}>
        {tokenName[0]}
      </StyledAvatar>
    </Badge>
  );
};
